// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.slide-enter-active[data-v-113611de] {\n  -webkit-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  -webkit-transition-timing-function: ease-in;\n  transition-timing-function: ease-in;\n}\n.slide-enter-to[data-v-113611de],\n.slide-leave[data-v-113611de] {\n  max-height: 100px;\n  overflow: hidden;\n}\n.slide-enter[data-v-113611de],\n.slide-leave-to[data-v-113611de] {\n  overflow: hidden;\n  max-height: 0;\n}\n", ""]);
// Exports
module.exports = exports;
